import api from '@/common/api';
import applyStatusHelper from '@/common/applyStatusHelper';
import RouteKey from '@/common/RouteKey';
import DateUtils from '@/common/DateUtils';
import MessageType from '@/components/common/message-box/MessageType';
import DescriptionFolder from '@/components/common/DescriptionFolder';
import SubMenu from '../common/SubMenu';
import { KeyEnum, DisplayMapper, OptionMapper } from '@/common/OptionConstant';
import DeviceUtils from '@/common/utils/DeviceUtils';
import FormItemUploadFile from '../common/FormItemUploadFile';
import ErrorHandler from './ErrorHandler';
import PasswordAdd from '../common/PasswordAdd';

const DateFormat = DateUtils.DateFormat;
const PlatformType = DisplayMapper.PLATFORM_TYPE;
const PlatformOptions = OptionMapper.PLATFORM_TYPE.filter((items) => {
  if (items.label === 'x86 Linux' || items.label === 'Android') {
    return items;
  }
});
const DeviceStatus = {
  INACTIVE: 1
};
const contractTitle = {
  [KeyEnum.JoinWay.INTERNAL]: '合作备案',
  [KeyEnum.JoinWay.EXTERNAL]: '正式合同'
};
const contractText = {
  [KeyEnum.JoinWay.INTERNAL]: '合作备案',
  [KeyEnum.JoinWay.EXTERNAL]: '合同文件'
};
const IS_SUCCESS = 'is-success';
const IS_ERROR = 'is-error';
const LIST_NUM = 100;

export default {
  name: 'OfflineSdkDisplay',
  components: {
    DescriptionFolder,
    SubMenu,
    PasswordAdd,
    FormItemUploadFile
  },
  data() {
    return {
      RouteKey,
      KeyEnum,
      pageSize: 20,
      sdkList: [],
      sdkIndexList: [],
      applyStatusHelper,
      loaded: false,
      validateFile: false,
      validateInfoFile: false,
      ErrorName: 'GROUPDEVICE',
      ErrorInfoName: 'DEVICE_INFO_ERROR',
      groupAddDeviceVisible: false,
      addDeviceVisible: false,
      contractVisible: false,
      deviceInfoVisible: false,
      addDeviceValidateData: {
        platform: '',
        devno: '',
        remark: ''
      },
      addDeviceRules: {
        platform: [{
          validator: this.validatePlatform,
          trigger: ['change', 'blur']
        }],
        devno: [{
          validator: this.validateDevno,
          trigger: ['change', 'blur']
        }]
      },
      bindDeviceSdkItem: null,
      contractSdkItem: null,
      PlatformOptions: PlatformOptions,
      DisplayMapper,
      SdkBindType: KeyEnum.SdkBindType,
      sdkApplyKeyType: KeyEnum.SdkApplyType,
      SdkStatusKey: KeyEnum.SdkApplyStatus,
      PlatformKey: KeyEnum.Platform,
      DeviceAuth: KeyEnum.DeviceAuth,
      PlatformType,
      DeviceStatus,
      contractTitle: contractTitle[KeyEnum.JoinWay.EXTERNAL],
      contractText: contractText[KeyEnum.JoinWay.EXTERNAL],
      validateFileContract: false,
      ErrorNameContract: 'INFO',
      contractFile: {
        file: null,
        isValid: false
      },
      validateGroupDeviceFileResult: {
        file: null,
        isValid: false
      },
      validateDeviceInfoFileResult: {
        file: null,
        isValid: false
      },
      renewalVisible: false,
      renewalVisibleFile: true,
      renewalValidateForm: {
        demand: ''
      },
      mailReceiverVisible: false,
      mailReceiverData: {
        receiver: ''
      },
      rulesReceiver: {
        receiver: [{
          type: 'string',
          required: true,
          message: '邮箱不能为空',
          trigger: ['blur, change']
        }, {
          max: 500,
          message: '不超过500字'
        }, {
          validator: ErrorHandler.validateMail,
          trigger: ['change', 'blur']
        }]
      },
      mailEditingItem: {},

      deviceShow: true,
      deviceGroupShow: false,
      deviceInfoShow: false,
      deviceInfoData: {
        remark: '',
        platform: ''
      },
      deviceInfoRules: {
        platform: [{
          validator: this.validateInfoPlatform,
          trigger: ['change', 'blur']
        }]
      },
      remarksData: {
        id: '',
        appid: '',
        devno: '',
        remark: ''
      },
      remarksVisible: false,
      showLinux: false,
      downloadSdk: {},
      addShow: false
    };
  },
  methods: {
    resetmailReceiverForm() {
      this.mailReceiverVisible = false;
      this.$refs.mailReceiverForm.resetFields();
    },
    showMailReceiverVisible(sdkItem) {
      if (sdkItem.mailreceiver.length > 0) {
        this.mailReceiverData.receiver = sdkItem.mailreceiver;
      }
      this.mailEditingItem = sdkItem;
      this.mailReceiverVisible = true;
    },
    submitChangeMailReceiver() {
      this.$refs.mailReceiverForm.validate((valid) => {
        if (valid) {
          this.mailReceiverVisible = false;
          const loading = this.loading();
          let mailreceiver = this.mailReceiverData.receiver;
          mailreceiver = mailreceiver.replace(/;/g, ',');
          mailreceiver = mailreceiver.replace(/；/g, ',');
          let data = {
            id: this.mailEditingItem.id,
            mailreceiver: mailreceiver
          };
          this.$loader.post(api.ytsdk.MAIL, data, this.ajaxErrorCallback).then(() => {
            this.getAllSdk();
          }).finally(() => {
            this.mailEditingItem.mailreceiver = mailreceiver;
            this.resetmailReceiverForm();
            loading.close();
          });
        }
      });
    },
    validateDevno(rule, value, callback) {
      let reg = /^[-:a-zA-Z0-9_]+$/;
      if (value === '') {
        return callback(new Error('请输入设备号'));
      }
      if (!reg.test(value)) {
        return callback(new Error('设备号格式错误，请输入数字、字母、英文冒号或-'));
      }
      callback();
    },
    validatePlatform(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请选择平台'));
      }
      let sdkItem = this.bindDeviceSdkItem;
      let data = this.addDeviceValidateData;
      data.id = sdkItem.id;
      if (sdkItem.platformList.indexOf(parseInt(data.platform)) === -1) {
        return callback(new Error('选择平台有误，请重新绑定'));
      }
      callback();
    },
    validateInfoPlatform(rule, value, callback) {
      if (value === '') {
        return callback(new Error('请选择平台'));
      }
      let sdkItem = this.bindDeviceSdkItem;
      let data = this.deviceInfoData;
      data.id = sdkItem.id;
      if (sdkItem.platformList.indexOf(parseInt(data.platform)) === -1) {
        return callback(new Error('选择平台有误，请重新绑定'));
      }
      callback();
    },
    // 验证备注
    validateRemarks(rule, value, callback) {
      if (value === '') {
        return callback(new Error('备注不能为空'));
      }
      if (value.indexOf('%') !== -1) {
        return callback(new Error('备注格式错误，不支持%'));
      }
      callback();
    },
    contractValidate(data) {
      let classItems = this.$refs.contract.$el.classList;
      this.handleValidateUploadResult(data, classItems, this.contractFile);
    },
    deviceValidateResult(data) {
      let classItems = this.$refs.deviceGroupFile.$el.classList;
      this.handleValidateUploadResult(data, classItems, this.validateGroupDeviceFileResult);
    },
    deviceInfoValidateResult(data) {
      let classItems = this.$refs.deviceInfoFile.$el.classList;
      this.handleValidateUploadResult(data, classItems, this.validateDeviceInfoFileResult);
    },
    handleValidateUploadResult(data, classItems, filesResult) {
      if (data.result === true || data.file != null) {
        classItems.add(IS_SUCCESS);
        classItems.remove(IS_ERROR);
        filesResult.isValid = data.result;
        filesResult.file = data.file;
        return;
      }
      classItems.add(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      filesResult.file = null;
      filesResult.isValid = false;
    },
    handleDeleteSdk(sdkId) {
      this.$confirm('确定删除该SDK?', '提示', MessageType.INFO).then(() => {
        this.confirmDeleteSdk(sdkId);
      });
    },
    confirmDeleteSdk(sdkId) {
      this.$loader.post(api.ytsdk.REMOVE_YTSDK, {id: sdkId}, this.ajaxErrorCallback).then(() => {
        this.getAllSdk();
        this.$alert('删除SDK成功', null, MessageType.SUCCESS);
      });
    },
    handleChangeToFormalSdk(sdkItem) {
      if (parseInt(sdkItem.scope) === KeyEnum.JoinWay.INTERNAL) {
        this.contractText = contractText[KeyEnum.JoinWay.INTERNAL];
        this.contractTitle = contractTitle[KeyEnum.JoinWay.INTERNAL];
      } else {
        this.contractText = contractText[KeyEnum.JoinWay.EXTERNAL];
        this.contractTitle = contractTitle[KeyEnum.JoinWay.EXTERNAL];
      }
      this.contractVisible = true;
      this.contractSdkItem = sdkItem;
    },
    handleApplyRenewalSdk(sdkItem) {
      this.contractTitle = '续期需求';
      if (parseInt(sdkItem.scope) === KeyEnum.JoinWay.INTERNAL) {
        this.contractText = contractText[KeyEnum.JoinWay.INTERNAL];
      } else {
        this.contractText = contractText[KeyEnum.JoinWay.EXTERNAL];
      }
      this.contractVisible = true;
      this.renewalVisible = true;
      if (sdkItem.applytype === this.sdkApplyKeyType.TEST) {
        this.renewalVisibleFile = false;
      }
      if (((sdkItem.status & this.SdkStatusKey.FORMAL_VERIFY_FAIL) === this.SdkStatusKey.FORMAL_VERIFY_FAIL) &&
        sdkItem.status !== this.SdkStatusKey.FORMAL_VERIFY_FAIL &&
        sdkItem.isrenewal !== 1) {
        this.renewalVisibleFile = false;
      }
      this.contractSdkItem = sdkItem;
    },
    cancleContractForm() {
      if (this.renewalVisibleFile) {
        let classItems = this.$refs.contract.$el.classList;
        classItems.remove(IS_ERROR);
        classItems.remove(IS_SUCCESS);
        this.contractFile.file = null;
      }
      if (this.renewalVisible) {
        this.$refs.contractForm.resetFields();
      }
      this.contractVisible = false;
      this.renewalVisible = false;
      this.renewalValidateForm.demand = '';
      this.validateFileContract = false;
      this.contractFile.isValid = false;
      this.renewalVisibleFile = true;
    },
    // 删除设备
    handleDeleteDevice(sdkItem, deviceItem) {
      if (deviceItem.status !== this.DeviceStatus.INACTIVE) {
        let data = {
          id: sdkItem.id,
          devno: deviceItem.devno
        };
        this.$confirm('确认删除该设备', '提示', MessageType.INFO).then(() => {
          const loading = this.loading();
          this.$loader.post(api.ytsdk.REMOVE_DEVICE, data, this.ajaxErrorCallback).then(() => {
            loading.close();
            this.getAllSdk();
          }).finally(() => {
            loading.close();
          });
        });
      }
    },

    // 手动绑定设备-添加设备
    handleDevice() {
      this.deviceShow = true;
      this.deviceGroupShow = false;
      this.deviceInfoShow = false;
      this.cancleBindGroupDevice();
      this.cancleBindDeviceInfo();
      if (this.$refs.addDeviceValidateData) {
        this.$refs.addDeviceValidateData.clearValidate();
      }
      if (this.$refs.deviceInfoData) {
        this.$refs.deviceInfoData.clearValidate();
      }
    },

    // 批量添加设备
    handleGroupDevice() {
      this.deviceShow = false;
      this.deviceGroupShow = true;
      this.deviceInfoShow = false;
      this.groupAddDeviceVisible = true;
      this.cancleBindDeviceInfo();
      this.cancleBindDevice();
      if (this.$refs.addDeviceValidateData) {
        this.$refs.addDeviceValidateData.clearValidate();
      }
      if (this.$refs.deviceInfoData) {
        this.$refs.deviceInfoData.clearValidate();
      }
    },

    // 添加设备信息
    handleDeviceInfo() {
      this.deviceShow = false;
      this.deviceGroupShow = false;
      this.deviceInfoShow = true;
      this.deviceInfoVisible = true;
      this.cancleBindGroupDevice();
      this.cancleBindDevice();
      if (this.$refs.addDeviceValidateData) {
        this.$refs.addDeviceValidateData.clearValidate();
      }
      if (this.$refs.deviceInfoData) {
        this.$refs.deviceInfoData.clearValidate();
      }
    },

    // 绑定设备
    bindDeviceToSdk(sdkItem) {
      this.showLinux = false;
      sdkItem.platformList.forEach(item => {
        if (item === 8) {
          this.showLinux = true;
        }
      });
      this.addDeviceVisible = true;
      this.bindDeviceSdkItem = sdkItem;
      if (this.$refs.addDeviceValidateData) {
        this.$refs.addDeviceValidateData.clearValidate();
        this.deviceShow = true;
        this.deviceInfoShow = false;
        this.deviceGroupShow = false;
      }
    },

    confirmBindDevice() {
      this.deviceInfoShow = false;
      this.deviceGroupShow = false;
      this.$refs.addDeviceValidateData.validate((valid) => {
        if (valid) {
          let sdkItem = this.bindDeviceSdkItem;
          let data = this.addDeviceValidateData;
          data.id = sdkItem.id;
          const loading = this.loading('绑定设备中');
          this.$loader.post(api.ytsdk.BIND_DEVICE, data, this.ajaxErrorCallback).then(() => {
            loading.close();
            this.$alert('设备绑定成功', null, MessageType.SUCCESS);
            return this.getAllSdk();
          }).finally(() => {
            this.addDeviceVisible = false;
            loading.close();
            this.cancleBindDevice();
          });
        }
      });
    },

    // 取消添加设备
    cancleBindDevice() {
      let classItems = this.$refs.addDeviceValidateData.$el.classList;
      classItems.remove(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      this.addDeviceValidateData.platform = '';
      this.addDeviceValidateData.devno = '';
      this.addDeviceValidateData.remark = '';
      this.$refs.addDeviceValidateData.clearValidate();
    },

    // 批量添加
    // bindGroupDeviceToSdk(sdkItem) {
    //   this.groupAddDeviceVisible = true;
    //   this.bindDeviceSdkItem = sdkItem;
    //   if (this.$refs.groupAddDeviceValidateData && this.$refs.groupAddDeviceValidateData.value) {
    //     this.$refs.groupAddDeviceValidateData.value = null;
    //   }
    // },

    confirmGroupBindDevice() {
      this.deviceShow = false;
      this.deviceInfoShow = false;
      this.validateFile = !(this.validateFile);
      if (this.validateGroupDeviceFileResult.isValid === false) {
        return;
      }
      let sdkItem = this.bindDeviceSdkItem;
      let data = {
        id: sdkItem.id
      };
      let file = {
        file: this.validateGroupDeviceFileResult.file
      };
      const loading = this.loading('绑定设备中');
      this.$loader.upload(api.ytsdk.MULTIBIND_DEVICE, data, file, this.ajaxErrorCallback).then(() => {
        loading.close();
        this.$alert('设备绑定成功', null, MessageType.SUCCESS);
        return this.getAllSdk();
      }).finally(() => {
        this.addDeviceVisible = false;
        loading.close();
        this.cancleBindGroupDevice();
      });
    },
    cancleBindGroupDevice() {
      let classItems = this.$refs.deviceGroupFile.$el.classList;
      this.validateFile = false;
      classItems.remove(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      this.$refs.groupAddDeviceValidateData.clearValidate();
      this.groupAddDeviceVisible = false;
      this.validateGroupDeviceFileResult = {
        file: null,
        isValid: false
      };
    },

    // 绑定设备信息
    confirmBindDeviceInfo() {
      this.deviceShow = false;
      this.deviceGroupShow = false;
      this.validateInfoFile = !(this.validateInfoFile);
      this.$refs.deviceInfoData.validate((valid) => {
        if (!valid || this.validateDeviceInfoFileResult.isValid === false) {
          return;
        }
        this.doSubmitDeviceInfo();
      });
    },
    doSubmitDeviceInfo() {
      let sdkItem = this.bindDeviceSdkItem;
      let data = {
        id: sdkItem.id,
        remark: this.deviceInfoData.remark,
        appid: sdkItem.appid,
        platform: this.deviceInfoData.platform
      };
      let file = {
        deviceInfo: this.validateDeviceInfoFileResult.file
      };
      const loading = this.loading('绑定设备信息中');
      this.$loader.upload(api.ytsdk.BIND_DEVICE_INFO, data, file, this.ajaxErrorCallback).then(() => {
        loading.close();
        this.$alert('授权成功', null, MessageType.SUCCESS);
        return this.getAllSdk();
      }).finally(() => {
        this.addDeviceVisible = false;
        loading.close();
        this.cancleBindDeviceInfo();
      });
    },

    cancleBindDeviceInfo() {
      let classItems = this.$refs.deviceInfoFile.$el.classList;
      this.validateInfoFile = false;
      classItems.remove(IS_ERROR);
      classItems.remove(IS_SUCCESS);
      this.deviceInfoData.remark = '';
      this.deviceInfoData.platform = '';
      this.deviceInfoVisible = false;
      this.$refs.deviceInfoData.clearValidate();
      this.validateDeviceInfoFileResult = {
        file: null,
        isValid: false
      };
    },

    confirmBindDeviceForm() {
      if (this.deviceShow) {
        this.confirmBindDevice();
        return;
      }
      if (this.deviceGroupShow) {
        this.confirmGroupBindDevice();
        return;
      }
      if (this.deviceInfoShow) {
        this.confirmBindDeviceInfo();
      }
    },

    cancleBindDeviceForm() {
      if (this.deviceGroupShow) {
        this.cancleBindGroupDevice();
      }
      if (this.deviceInfoShow) {
        this.cancleBindDeviceInfo();
      }
      if (this.deviceShow) {
        this.cancleBindDevice();
      }
      this.addDeviceVisible = false;
      this.deviceShow = true;
      this.deviceInfoShow = false;
      this.deviceGroupShow = false;
      this.deviceInfoVisible = false;
      this.groupAddDeviceVisible = false;
    },

    getAllSdk() {
      this.$loader.post(api.ytsdk.GET_ALL_YTSDK, {limit: LIST_NUM}, this.ajaxErrorCallback).then(res => {
        this.loaded = true;
        res.items.forEach(sdkItem => {
          sdkItem.contract = sdkItem.contract.split(',');
          sdkItem.expired = (sdkItem.validend - Date.parse(new Date()) < 0);
          sdkItem.mailreceiver = sdkItem.mailreceiver == null ? sdkItem.mailreceiver : sdkItem.mailreceiver.replace(/,/g, ';');
          sdkItem.ytcontact = sdkItem.ytcontact == null ? sdkItem.ytcontact : sdkItem.ytcontact.replace(/,/g, ';');
          sdkItem.optime = DateUtils.format(new Date(sdkItem.optime), DateFormat.DEFAULT);
          sdkItem.validbegin = sdkItem.validbegin === 0 ? null : DateUtils.format(new Date(sdkItem.validbegin), DateFormat.DEFAULT);
          sdkItem.validend = sdkItem.validend === 0 ? null : DateUtils.format(new Date(sdkItem.validend), DateFormat.DEFAULT);
          if (sdkItem.busstype === 0) {
            sdkItem.busstype = '--';
          } else {
            sdkItem.busstype = DisplayMapper.SDK_SERVICE_TYPE[sdkItem.busstype];
          }
          sdkItem.deviceStatistics = DeviceUtils.processSDK(sdkItem);
          if (sdkItem.devices == null) {
            sdkItem.devices = [{}, {}, {}, {}, {}];
          }
          let lengthDevice = sdkItem.devices.length;
          if (lengthDevice < 5) {
            for (let i = lengthDevice; i < 5; i++) {
              sdkItem.devices[i] = {};
            }
          }
          let sdkType = [];
          let sdks = [];
          let platformList = [];
          sdkItem.stinfo.forEach((item) => {
            if (item.type !== 0) {
              sdkType.push(item.name + '(' + PlatformType[item.platform] + ')');
              sdks.push(item);
              platformList.push(item.platform);
            }
          });
          sdkItem.platformList = platformList;
          sdkItem.sdks = sdks;
          sdkItem.sdktypeAdd = sdkType.join('、');
        });
        this.sdkList = res.items;
        this.sdkList.forEach(item => {
          this.sdkIndexList.push(1);
        });
      });
    },
    confirmApplyAuth() {
      this.validateFileContract = !(this.validateFileContract);
      if (this.contractFile.isValid === false) {
        return;
      }
      this.doSumbitApply();
    },
    confirmRenewalAuth() {
      if (this.renewalVisibleFile) {
        this.validateFileContract = !(this.validateFileContract);
        this.$refs.contractForm.validate((valid) => {
          if (valid && this.contractFile.isValid !== false) {
            this.doSumbitApply();
          }
        });
        return;
      }
      this.$refs.contractForm.validate((valid) => {
        if (valid) {
          this.doSumbitApply();
        }
      });
    },
    doSumbitApply() {
      const loading = this.loading();
      let data = {
        id: this.contractSdkItem.id,
        applytype: this.contractSdkItem.applytype
      };
      if (((this.contractSdkItem.status & this.SdkStatusKey.FORMAL_VERIFY_FAIL) === this.SdkStatusKey.FORMAL_VERIFY_FAIL) &&
        this.contractSdkItem.status !== this.SdkStatusKey.FORMAL_VERIFY_FAIL &&
        this.contractSdkItem.isrenewal !== 1) {
        data.applytype = this.sdkApplyKeyType.TEST;
      }
      let url = api.ytsdk.PRODUCTIZE_AUTH;
      let file = null;
      if (this.renewalVisible) {
        data.renewaldemand = this.renewalValidateForm.demand;
        url = api.ytsdk.RENEWAL;
      }
      if (this.renewalVisibleFile) {
        file = {
          contract: this.contractFile.file
        };
      }
      this.$loader.upload(url, data, file, this.ajaxErrorCallback).then(() => {
        this.getAllSdk();
      }).finally(() => {
        this.cancleContractForm();
        loading.close();
      });
    },
    // 申请数量超限
    openCreateSdk() {
      if (this.sdkList.length >= LIST_NUM) {
        this.$alert('可申请离线SDK数量上限为100，如需继续申请，请删除列表中的部分授权', '申请数量超限', MessageType.FAIL);
      } else { // 跳转创建SDK
        this.$router.transfer(RouteKey.OPEN_SDK_CREATOR, {id: this.sdkList[0].id});
      }
    },

    // 修改备注
    showUpdateRemarks(id, appid, name, remark) {
      this.remarksVisible = true;
      this.remarksData.appid = appid;
      this.remarksData.devno = name;
      this.remarksData.id = id;
      this.remarksData.remark = remark;
    },
    submitRemarksData() {
      this.$refs.remarksRef.validate((valid) => {
        if (!valid) {
          return;
        }
        const loading = this.loading();
        this.remarksData.remark = this.remarksData.remark.trim();
        this.$loader.post(api.ytsdk.UPDATE_REMARKS, this.remarksData, this.ajaxErrorCallback).then(() => {
          this.resetRemarksData();
          this.getAllSdk();
        }).finally(() => {
          this.resetRemarksData();
          loading.close();
        });
      });
    },
    resetRemarksData() {
      this.remarksVisible = false;
      this.remarksData.remark = '';
      this.$refs.remarksRef.clearValidate();
    },

    openNewPage(url) {
      window.open(url, '_blank');
    },

    // 下载sdk
    downloadSdkRecord(val, sdkUrl) {
      if (!sdkUrl) {
        return;
      }
      let data = {
        id: val.id,
        deliverytype: 2,
        appid: val.appid,
        operator: '客户下载',
        option: 1, // 外部下载
        count: 1,
        company: val.extname,
        scope: val.scope,
        mailreceiver: '无',
        description: val.description,
        sdkname: '',
        platform: '',
        version: '',
        end: '无',
        url: sdkUrl
      };
      val.sdks.forEach(item => {
        if (sdkUrl === item.url) {
          data.sdkname = item.name;
          data.platform = item.platform;
          data.version = item.version;
        }
      });
      this.$loader.post(api.ytdelivery.CREATE_DOWNLOAD, data).then(() => {
      });
    },

    // 下载授权
    downloadCSV(sdkItem, deviceItem) {
      let data = {
        id: sdkItem.id,
        appid: sdkItem.appid,
        platform: deviceItem.platform,
        devno: deviceItem.devno
      };
      this.$loader.downloadFileValidate(api.ytsdk.QUERY_LICENSE, data, '');
    },

    // 通过密码添加
    openAddDialog() {
      this.addShow = true;
    }
  },
  created() {
    this.ajaxErrorCallback = ErrorHandler.ajaxErrorCallback(this);
    this.getAllSdk();
  }
};



// WEBPACK FOOTER //
// ./src/components/open/panels/application/panels/js/OfflineSdkDisplay.js